/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const preferenceSchema = z
  .object({
    primaryLanguage: z.string().nullable(),
    detectiveMode: z.boolean().nullable(),
    proficiencyScore: z.number().nullable(),
  })
  .nullable();

export type IPreference = z.infer<typeof preferenceSchema>;
